import React, { useState, useEffect, useMemo } from 'react'
import { useTable, useBlockLayout, useResizeColumns, useExpanded, useRowSelect } from 'react-table';
import { useSticky } from 'react-table-sticky';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { Pagination, TableLoader } from "components";

import { useCheckboxes } from 'hooks';

import "assets/scss/components/tables/generalTable.scss";
import { cloneArrayOfObject, cloneObject, getArrayLength, getObjectPropertyValue, 
    getStringUniqueId, isArrayNotEmpty, isFunction, isNotNullUndefined, 
    isNumberValid, isObjectNotEmpty, isStringTrimNotEmpty } from 'functions';
import { useTabs } from 'hooks/useTabs/useTabs';



export function GeneralTable(props) {
    const { 
        className, wrapperclassName,
        tableWrapperClassName,
        lastRowClassName,
        outerTableHeaderTopClassName,
        outerTableHeaderClassName, bottomOuterTableHeader, 
        topOuterTableHeader, outerTableHeader,
        headerClassName, headerRowClassName, isHeaderHidden,

        tableOptions, isTabRequired,

        persistentFilterOptions, defaultFilter,

        bodyClassName, bodyRowClassName,

        data,

        pageSize: pageSize_props,

        subrowComponent,

        isTableRefreshRequired, isTableDataLoading,
        isTableEvenRowsDarken, isTableOddRowsDarken,
        isTableHeightAdjustmentOptional, isNoDataHidden,

        isColumnResizeable, isAllColumnWidthEqual,
        isStickyColumnBoxShadowsVisible,
        // rowSelectionLimit,
        minRows,

        // Functions
        onRowSelectionChange,
        onIndexSelectionChange
     } = props;

    // Checkbox
    const { isCheckboxColumnFirst } = props;

	// Pagination
    const { isUsingPagination, totalRecords } = props;

    let tableOptions_validated = isObjectNotEmpty(tableOptions)? tableOptions:{};
    
    
    // States

    let defaultFilter_valdiated = isObjectNotEmpty(defaultFilter)? defaultFilter:{};
	const [filterOptions, setFilterOptions] = useState(defaultFilter_valdiated);
	const [sort] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(pageSize_props? pageSize_props: 10);
    const [isTableReset, setIsTableReset] = useState();

    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedIndexes, setSelectedIndexes] = useState([]);

    const [expandedRowIdxObj, setExpandedRowIdxObj] = useState({});

    const [isTableHeightAdjusted, setIsTableHeightAdjusted] = useState(false);
    
    // For the purpose of element ids
    // const [tableUniqueId] = useState(getStringUniqueId("component-generalTable-table"));
    const [tableWrapperUniqueId] = useState(getStringUniqueId("component-generalTable_wrapper"));
    const [headerRowUniqueId] = useState(getStringUniqueId("component-generalTable-header-row"));
    const [tableBodyUniqueId] = useState(getStringUniqueId("component-generalTable-body"));
    const [tableRowUniqueId] = useState(getStringUniqueId("component-generalTable-body-row"));
    const [paginationUniqueId] = useState(getStringUniqueId("component-generalTable-pagination"));

    // Expander column
	let columns_formatted = useExpanderColumn({ 
        ...props,
        handleExpandedRowIdx,
        currentPage, pageSize, sort, filterOptions
    });

    // Checkbox column
    columns_formatted = useCheckboxColumn({
        ...props,
        columns: columns_formatted,
        setSelectedRows,
        isTableRefreshRequired,
        isTableReset, setIsTableReset,
        setSelectedIndexes
    });

    useEffect(() => {
        if (isFunction(onRowSelectionChange)) {
            onRowSelectionChange(selectedRows);
        }
    }, [JSON.stringify(selectedRows)]);

    useEffect(() => {
        if (isFunction(onIndexSelectionChange)) {
            onIndexSelectionChange(selectedIndexes);
        }
    }, [JSON.stringify(selectedIndexes)]);

	let data_formatted = useMemo(() => { 
		if (isArrayNotEmpty(data)) {
            if (isNotNullUndefined(subrowComponent)) {
                return data.map((details) => {
                    return {
                        ...details,
                        subRows: [{}]
                    }
                })
            }
            return data;
        } 
		return [];
    }, [JSON.stringify(data)]);
    
    // Check if all subrows are empty
    let isAnyRowExpandable = false;
    if (isArrayNotEmpty(data_formatted)) {
        data_formatted.map((row) => {
            let subRows = getObjectPropertyValue(row, "subRows");
            if (isObjectNotEmpty(subRows) ||
                isArrayNotEmpty(subRows))
                isAnyRowExpandable = true;
        })
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,

        toggleRowExpanded,
        toggleAllRowsExpanded,
        
        selectedFlatRows,
        state: { selectedRowIds },
    } = useTable(
        {
            columns: columns_formatted,
            data: data_formatted,
            initialState: {
                expanded: expandedRowIdxObj,
                hiddenColumns: (!isAnyRowExpandable)? ['expander']:[]
            },
            ...tableOptions_validated
        },
        useBlockLayout,
        useResizeColumns,
        useExpanded,
        useRowSelect,
        useSticky
    )

    function handleExpandedRowIdx(isExpanded, rowIdx, rowsObj) {
        let expandedRowIdxObj_new = cloneObject(expandedRowIdxObj);

        if (isNumberValid(rowIdx) &&
            isArrayNotEmpty(rowsObj)) {
            
            if (isExpanded) {
                toggleAllRowsExpanded(false)

                rowsObj.map((row, idx) => {
                    if (idx == rowIdx) {
                        expandedRowIdxObj_new[idx] = true; // Update initial expanded rows 
                    }
                    else {
                        expandedRowIdxObj_new[idx] = false; // Update initial expanded rows 
                    }
                });
            }
            else {
                rowsObj.map((row, idx) => {
                    let isExpanded = getObjectPropertyValue(row, "isExpanded");
                    expandedRowIdxObj_new[idx] = false; // Update initial expanded rows 

                    if (isExpanded &&
                        (idx != rowIdx)) 
                        toggleRowExpanded(idx); // Update current expanded rows
                });
            }

            setExpandedRowIdxObj(expandedRowIdxObj_new);
        }        
    }
    useEffect(() => {
        // Reset row expansions
        setExpandedRowIdxObj({});
        toggleAllRowsExpanded(false);
    }, [currentPage]);

    useTableData({
        ...props,
        
        currentPage, setCurrentPage,
        pageSize, 
        sort, 
        filterOptions,

        data,
        
        tableWrapperUniqueId,
        tableRowUniqueId,

        isTableRefreshRequired, 
        getTableData: props.getTableData,
        isTableHeightAdjusted,
        isTableHeightAdjustmentOptional
    });
    

    let minRows_formatted = 5;
	let totalRecords_validated = 0;

	if (isNumberValid(minRows)) minRows_formatted = minRows;
	if (isNumberValid(totalRecords) && totalRecords > 0) totalRecords_validated = totalRecords;
    let pageCount = Math.ceil(totalRecords_validated / pageSize);
    
    useTableHeightAdjustment({
        isUsingPagination,
        tableWrapperUniqueId,
        headerRowUniqueId,
        tableRowUniqueId,
        paginationUniqueId,
        pageCount,

        isTableDataLoading,
        isTableHeightAdjusted,
        isTableHeightAdjustmentOptional,

        pageSize_props,
        setPageSize,
        setIsTableHeightAdjusted,

        data,
        totalRecords,

        isHeaderHidden
    });

    useTableHeightWrap({
        ...props,
        tableWrapperUniqueId,
        headerRowUniqueId,
        tableRowUniqueId,
        isTableDoneRendering: (
            (isTableHeightAdjusted || isTableHeightAdjustmentOptional) && 
            (!isTableDataLoading)
        ),
    });

    function handleOnRowClick(rowDetails) {
        if (props.onRowClick)
            props.onRowClick(rowDetails);
    }

    const {
        tabsDisplay, currentTabId
    } = useTabs({
        ...props,
        onClick: (id, filters) => {
            setIsTableReset(true);
            setCurrentPage(0);

            let filters_formatted = filters;
            if (isArrayNotEmpty(persistentFilterOptions)) {
                persistentFilterOptions.map((propertyName) => {
                    if (isStringTrimNotEmpty(propertyName)) {
                        filters_formatted[propertyName] = filterOptions?.[propertyName];
                    }
                });
            }
            setFilterOptions(filters_formatted);
            setExpandedRowIdxObj({});
        }
    });

    return (
        <div className={"component-generalTable " + 
                (className? className + " ":"")}>
            {/* Tabs */}
            {isTabRequired? tabsDisplay:""}
            
            <div {...getTableProps()}
                className={"component-generalTable_wrapper d-flex flex-column " + 
                    (wrapperclassName? wrapperclassName + " ":"")}
            >
                {/* Outer Table Header */}
                {topOuterTableHeader || outerTableHeader || bottomOuterTableHeader? (
                    <div className={"component-generalTable-outerTableHeader " +
                            (outerTableHeaderClassName? outerTableHeaderClassName + " ":"")}>
                        {/* Top */}
                        {isFunction(topOuterTableHeader)? 
                            topOuterTableHeader({ filterOptions, setFilterOptions, selectedRows })
                        :""}

                        {/* Middle */}
                        <div className={"component-generalTable-outerTableHeader-top " +
                            (outerTableHeaderTopClassName? outerTableHeaderTopClassName + " ":"")}>
                            {isFunction(outerTableHeader)? 
                                outerTableHeader({ filterOptions, setFilterOptions, selectedRows }):""}
                        </div>

                        {/* Bottom */}
                        {isFunction(bottomOuterTableHeader)? 
                            bottomOuterTableHeader({ filterOptions, setFilterOptions, selectedRows }):""}
                    </div>
                ):""}

                <div id={tableWrapperUniqueId} 
                    className={"component-generalTable-tableWrapper d-flex flex-column flex-fill " +
                        (tableWrapperClassName? tableWrapperClassName + " ":"") +
                        (isStickyColumnBoxShadowsVisible? "component-generalTable-tableWrapper_expanderBoxShadow ":"") +
                        (!isUsingPagination? "component-generalTable-tableWrapper_bottom-border ":"")}>
                    {/* Table Header */}
                    {isHeaderHidden? "":(
                        <div className={"component-generalTable-header header " +
                                (headerClassName? headerClassName + " ":"")}
                        >
                            {headerGroups.map(headerGroup => (
                                <div {...headerGroup.getHeaderGroupProps()} 
                                    name={headerRowUniqueId}
                                    id={headerRowUniqueId}
                                    className={"component-generalTable-header-row d-flex " +
                                        (headerRowClassName? headerRowClassName + " ":"")}
                                >
                                    {headerGroup.headers.map((column, columnIdx) => {
                                        let headerCellClassName = getObjectPropertyValue(column, "headerCellClassName");
                                        let isWidthResizingDisabled = getObjectPropertyValue(column, "isWidthResizingDisabled");

                                        let isCheckboxOrExpander = (column?.id == "expander" || column?.id == "checkbox");

                                        return (
                                            <div {...column.getHeaderProps()}
                                                className={"component-generalTable-headerRow-cell d-flex flex-shrink-0 align-items-center " +
                                                    (!column?.isHeaderMultipleLines? "noWrap-text-ellipsis ":"") +
                                                    (column?.isRightColumnBorderVisible? "component-generalTable-headerRow-cell-rightBorder ":"") +
                                                    (isCheckboxColumnFirst? "component-generalTable-headerRow-cell-checkbox ":"") +
                                                    (isAllColumnWidthEqual && !isCheckboxOrExpander? "flex-fill ":"") + 
                                                    (isCheckboxOrExpander? "component-generalTable-headerRow-cell_hide-resizer ":"") +
                                                    (headerCellClassName? headerCellClassName + " ":"")}
                                            >
                                                {column.render('Header')}

                                                {isColumnResizeable && (!isWidthResizingDisabled)? (
                                                    <div
                                                        {...column.getResizerProps()}
                                                        className={"resizer"}
                                                    />
                                                ):""}
                                            </div>
                                        )
                                    })}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Table Body */}
                    <div {...getTableBodyProps()} id={tableBodyUniqueId}
                        className={"component-generalTable-body flex-fill " +
                            (bodyClassName? bodyClassName + " ":"")}
                    >
                        {(!isTableDataLoading)?
                            isArrayNotEmpty(rows)?
                                rows.map((row, rowIdx) => {
                                    prepareRow(row);

                                    let rowDepth = getObjectPropertyValue(row, "depth");
                                    let isExpanded = getObjectPropertyValue(row, "isExpanded");
                                    let isSubrow = (rowDepth == 1);

                                    let isEvenRows = ((rowIdx % 2) == 0);
                                    let isEvenRowsDarken = isEvenRows && isTableEvenRowsDarken;
                        
                                    let isOddRows = ((rowIdx % 2) == 1);
                                    let isOddRowsDarken = isOddRows && isTableOddRowsDarken;
                        
                                    let isRowDarken = isEvenRowsDarken || isOddRowsDarken;

                                    let isLastRow = rowIdx === rows.length - 1;

                                    return (
                                        <div {...row.getRowProps()}
                                            id={tableRowUniqueId}
                                            name={tableRowUniqueId}
                                            className={"component-generalTable-body-row d-flex flex-column " + 
                                                (bodyRowClassName? bodyRowClassName + " ":"") +
                                                (isRowDarken? "component-generalTable-body-row_darkBackground ":"") +
                                                (props.onRowClick? "component-generalTable-body-row_clickable ":"") +
                                                ((isTableHeightAdjusted || isTableHeightAdjustmentOptional)? "":"invisible ") +
                                                (isExpanded? "component-generalTable-body-row_selected ":"") +
                                                (isSubrow? "component-generalTable-body-row_subrow ":"") +
                                                (isLastRow? lastRowClassName + " ":"")}
                                            onClick={() => { handleOnRowClick(row); }}
                                        >
                                            {(isNotNullUndefined(subrowComponent) && isSubrow)? "":(
                                                <div className={"component-generalTable-body-rowWrapper d-flex flex-fill "}>
                                                    {row.cells.map((cell, columnIdx) => {
                                                        let bodyCellClassName = getObjectPropertyValue(cell.column, "bodyCellClassName");
                                                        let isCheckboxOrExpander = (cell?.column?.id == "expander" || cell?.column?.id == "checkbox");

                                                        return (
                                                            <div {...cell.getCellProps()} key={columnIdx}
                                                                className={"component-generalTable-bodyRow-cell d-flex align-items-start flex-shrink-0 " +
                                                                    (cell?.column?.isRightColumnBorderVisible? "component-generalTable-bodyRow-cell-rightBorder ":"") +
                                                                    (isCheckboxColumnFirst? "component-generalTable-bodyRow-cell-checkbox ":"") +
                                                                    (bodyCellClassName? bodyCellClassName + " ":"") +
                                                                    (isAllColumnWidthEqual && !isCheckboxOrExpander? "flex-fill ":"")}
                                                            >
                                                                {cell.render('Cell')}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )}

                                            {/* Subrow (Spans Entire Row) */}
                                            {((row.isExpanded) && 
                                                isNotNullUndefined(subrowComponent))? (

                                                <div className={"component-generalTable-body-row-subrow"}>
                                                    {subrowComponent(row)}
                                                </div>
                                            ):""}
                                        </div>
                                    )
                                })
                            :(isNoDataHidden? "":(
                                <div className={"component-generalTable-body-noData"}>
                                    No Data
                                </div>
                            ))
                        :(<TableLoader/>)}
                    </div>
                </div>
                
            </div>

            {/* Pagination */}
            {isUsingPagination? (
                <Pagination
                    className="component-generalTable-pagination"
                    componentId={paginationUniqueId}

                    totalPages={pageCount}
                    pageRange={4}
                    currentPage={currentPage}
                    currentPageSize={pageSize}
                    totalRecords={totalRecords_validated}

                    onPageChange={(pageNo, pageSize) => {
                        setCurrentPage(pageNo);
                        setPageSize(pageSize);
                    }}
                />
            ):""}
        </div>
    )
}

function useExpanderColumn(props) {
    const { 
        columns, data,
        isExpanderRequired, isRowExpanderColumnFirst,
        expanderWidth,

        currentPage, pageSize, sort, filterOptions
    } = props;
    
    let expanderColumn = useMemo(() =>{ 
        if (isArrayNotEmpty(columns)) {
            let column_modified = cloneArrayOfObject(columns);

            let rowExpanderColumn = [{
                headerCellClassName: "component-generalTable-expanderColumn-header",
                id: 'expander',
                sticky: 'left',
                bodyCellClassName: "component-generalTable-expanderColumn-body d-flex align-items-center justify-content-center",
                isWidthResizingDisabled: true,
                Cell: (tableProps) => {
                    let row = getObjectPropertyValue(tableProps, "row");
                    let rows = getObjectPropertyValue(tableProps, "rows");

                    let isRowExpanded = row.isExpanded;
                    let expandIcon = isRowExpanded? faChevronUp: faChevronDown;

                    let rowIdx = getObjectPropertyValue(row, "index");

                    return (row.canExpand?
                        <span
                            {...row.getToggleRowExpandedProps()}
                        >
                            <FontAwesomeIcon 
                                className={"generalTable-bodyColumn-expandIcon"} 
                                icon={expandIcon} 
                                onClick={() => { 
                                    if (props.handleExpandedRowIdx)
                                        props.handleExpandedRowIdx(!isRowExpanded, rowIdx, rows); 

                                    if (props.onRowExpanded && !isRowExpanded)
                                        props.onRowExpanded(row, currentPage, pageSize, sort, filterOptions);
                                }}
                            />
                        </span>
                    :"");
                },
                width: (isNumberValid(expanderWidth))? expanderWidth: 40
            }];
    
            if (isRowExpanderColumnFirst) {
                column_modified = rowExpanderColumn.concat(column_modified);
            }
            else column_modified = column_modified.concat(rowExpanderColumn);

            return column_modified;
        }
        return [];
    }, [JSON.stringify(data), JSON.stringify(columns)]);

    if (isExpanderRequired) return expanderColumn;
    else return columns;
}

function useCheckboxColumn(props) {
    const { 
        columns, data, 
        isCheckboxRequired, isCheckboxColumnFirst, isExpandedRowCheckboxVisible ,
        isTableRefreshRequired, isTableReset, isCheckboxColumnFirstNotVisible,

        // Funtions
        onCheckboxDisabledValidationList = () => {}
    } = props;

    const {
        MainCheckbox,
        subCheckboxes,

        selectedData, selectedIndexes,

        isMainCheckboxChecked, isMainCheckboxIndeterminate, isCheckboxCheckedLimitReached, 
		checkboxIDList, isResetRequired,

        reset,
    } = useCheckboxes({
        dataList: data,
        updateParentState: props.setSelectedRows,
        initSelectedIndexes: props.initCheckboxSelectedRows
    });
    useEffect(() => {
        reset();
    }, [JSON.stringify(data)]);
    useEffect(() => {
        if (isTableRefreshRequired) reset();
    }, [isTableRefreshRequired]);
    useEffect(() => {
        if (isTableReset) {
            reset();
            
            if (isFunction(props.setIsTableReset)) props.setIsTableReset(false);
        }
    }, [isTableReset]);
    useEffect(() => {
        props.setSelectedIndexes(Object.keys(selectedIndexes));
    }, [JSON.stringify(selectedIndexes)]);
    
    let checkboxColumn = useMemo(() =>{ 
		if (isArrayNotEmpty(columns)) {
            let column_modified = cloneArrayOfObject(columns);

            let isMainCheckboxDisabled = false;
            if (isArrayNotEmpty(data)) {
                for (let i = 0; i < data.length; i++) {
                    if (data[i]?.isCheckboxDisabled) {
                        isMainCheckboxDisabled = true;
                        break;
                    }
                }
            }

            let checkboxColumn = [{
                headerCellClassName: "component-generalTable-checkboxColumn-header align-items-center",
                ...(!isCheckboxColumnFirstNotVisible)? {
                    Header: (
                        <MainCheckbox
                            className={"component-generalTable-checkboxColumn-main "}
                            iconClassName={"component-generalTable-checkboxColumn-mainIcon"}
                            isDisabled={isMainCheckboxDisabled}
                        />
                    )
                }:{},
                id: 'checkbox',
                sticky: 'left',
                isWidthResizingDisabled: true,
                bodyCellClassName: "component-generalTable-checkboxColumn-body align-items-center",
                Cell: ({ row }) => {
                    let index = getObjectPropertyValue(row, "index");

                    let subCheckbox = subCheckboxes({
                        disabledList: onCheckboxDisabledValidationList(row, selectedIndexes, data),
                        isDisabled: row?.original?.isCheckboxDisabled
                    })[index];


                    let depth = getObjectPropertyValue(row, "depth");
                    let isSubrow = (depth > 0);

                    let output = isSubrow? ""
                        :(subCheckbox? subCheckbox:"" );

                    return (
                        <div className={(!isCheckboxRequired)? "invisible ":""}>
                            {output}
                        </div>
                    );
                },
                width: 30
            }];
    
            if (isCheckboxColumnFirst) {
                column_modified = checkboxColumn.concat(column_modified);
            }
            else column_modified = column_modified.concat(checkboxColumn);

            return column_modified;
        }
		return [];
    }, [
        JSON.stringify(selectedData), JSON.stringify(data),
        JSON.stringify(columns),
        isMainCheckboxChecked, isMainCheckboxIndeterminate, isCheckboxCheckedLimitReached, 
		checkboxIDList, isResetRequired
    ]);

    if (isCheckboxRequired) return checkboxColumn;
    return columns;
}


function useTableData(props) {
    const { 
        currentPage, pageSize, sort, data,
        tableWrapperUniqueId, tableRowUniqueId,
        filterOptions, isTableRefreshRequired, isTableHeightAdjusted,
        isTableHeightAdjustmentOptional,
        isTableDataRequestPrevented,

        // Functoins
        setCurrentPage,
        onFilterUpdate
    } = props;

    function getTableData() {
        let rowEle = document.getElementById(tableRowUniqueId);
        if ((!rowEle) ||
            (rowEle && isTableHeightAdjusted && (!isTableHeightAdjustmentOptional))) {

            if (props.getTableData && (!isTableDataRequestPrevented)) {
                props.getTableData(currentPage, pageSize, sort, filterOptions);

                // Reset horizontal scroll to zero
                let tableEle = document.getElementById(tableWrapperUniqueId);
                tableEle.scrollLeft = 0;
                tableEle.scrollTop = 0;
            }
        }
    }
    useEffect(() => {
        getTableData();
    }, [currentPage, pageSize, filterOptions]);
    useEffect(() => {
        if (isFunction(onFilterUpdate)) onFilterUpdate(filterOptions);
    }, [filterOptions]);
    useEffect(() => {
        if (isTableRefreshRequired) {
            if (getArrayLength(data) == 1 && isFunction(setCurrentPage) && currentPage > 0) {
                setCurrentPage(currentPage - 1);
            }
            else getTableData();
        }
    }, [isTableRefreshRequired]);
    useEffect(() => {
        if (isFunction(setCurrentPage))
            setCurrentPage(0); // reset
    }, [sort, filterOptions])
}

function useTableHeightAdjustment(props) {
    const { 
        isUsingPagination, isTableHeightAdjusted, isTableHeightAdjustmentOptional,
        tableWrapperUniqueId, headerRowUniqueId, tableRowUniqueId, 
        paginationUniqueId, pageCount,
        isTableDataLoading,

        data, totalRecords,

        isHeaderHidden
    } = props;

    function adjustTableHeight() {
        // Find leftover gap between table and bottom of page.

        // Get table info
        let tableWrapperEle = document.getElementById(tableWrapperUniqueId);
        let tableWrapperEleRect = tableWrapperEle.getBoundingClientRect();
        let tableWrapperBottomPos = tableWrapperEleRect.bottom;
        let tableWrapperHeight = tableWrapperBottomPos - tableWrapperEleRect.top;
    
        let lefoverTableHeight = window.innerHeight - tableWrapperBottomPos - 25; // 25 is 25px padding because of id=dashboard-main

        // Get new table height

        let tableWrapperEle_computedStyle = window.getComputedStyle(tableWrapperEle);

        let tableWrapperMinHeight_string = tableWrapperEle_computedStyle.getPropertyValue("min-height").replace(/\D*/g,"");
        let tableWrapperMinHeight_stringValidated = isStringTrimNotEmpty(tableWrapperMinHeight_string)? tableWrapperMinHeight_string: 0;
        let tableWrapperMinHeight = parseFloat(tableWrapperMinHeight_stringValidated);

        // let tableWrapperMaxHeight_string = tableWrapperEle_computedStyle.getPropertyValue("max-height").replace(/\D*/g,"");
        // let tableWrapperMaxHeight_stringValidated = isStringTrimNotEmpty(tableWrapperMaxHeight_string)? tableWrapperMaxHeight_string: 0;
        // let tableWrapperMaxHeight = parseFloat(tableWrapperMaxHeight_stringValidated);

        let tableHeight_new = tableWrapperHeight + lefoverTableHeight;
        if (tableHeight_new < tableWrapperMinHeight) tableHeight_new = tableWrapperMinHeight;
        // if (tableHeight_new > tableWrapperMaxHeight) tableHeight_new = tableWrapperMaxHeight;

        // Set Table height

        // Calculate total rows
        let rowEle = document.getElementById(tableRowUniqueId);
        let headerRowEle = document.getElementById(headerRowUniqueId);
        if (rowEle) {
            let rowEleRect = rowEle.getBoundingClientRect();
            let rowHeight = rowEleRect.height;
    
            let tableBodyHeight = tableHeight_new;
            if (!isHeaderHidden) {
                let headerRowEleRect = headerRowEle.getBoundingClientRect();
                let headerRowHeight = headerRowEleRect.height;
                tableBodyHeight = tableHeight_new - headerRowHeight;
            }

            let totalRows = Math.floor(tableBodyHeight / rowHeight);
    
            // Update table height
            let pageCount_new = Math.ceil(totalRecords / totalRows);
            let paginationHeight = 0;
            if (isUsingPagination && (pageCount_new > 1)) {
                let paginationEle = document.getElementById(paginationUniqueId);
                let paginationEleRect = paginationEle.getBoundingClientRect();
        
                // 25 is 25px padding because of id=dashboard-main
                paginationHeight = paginationEleRect.height;
                tableHeight_new -= paginationHeight;
            }
            tableWrapperEle.style.height = tableHeight_new + "px";

            // Update total rows after pagination taken into account
            if (paginationHeight > 0) {
                totalRows -= (Math.floor(paginationHeight / rowHeight));
            }

            // Set the new table body height and pageSize (totalRows)
            if (props.setPageSize && totalRows > 0 && !props.pageSize_props)
              props.setPageSize(totalRows);
        }

        if (props.setIsTableHeightAdjusted) props.setIsTableHeightAdjusted(true);
    }

    useEffect(() => {
        let rowEle = document.getElementById(tableRowUniqueId);
        if (!isTableHeightAdjusted && rowEle && (!isTableHeightAdjustmentOptional)) 
            adjustTableHeight();
    }, [isTableDataLoading, JSON.stringify(data)]);
}

function useTableHeightWrap(props) {
    const { 
        isTableDoneRendering, isWrapHeightRequired, 
        tableWrapperUniqueId, tableRowUniqueId, headerRowUniqueId
    } = props;

    function wrapHeight() {
        if (isWrapHeightRequired) {
            let rowList = document.getElementsByName(tableRowUniqueId);
            let headerList = document.getElementsByName(headerRowUniqueId);
            let tableWrapperEle = document.getElementById(tableWrapperUniqueId);

            if (isObjectNotEmpty(rowList) &&
                isObjectNotEmpty(headerList) &&
                tableWrapperEle) {
                // Get last row
                // NOTE: Nodelist variable is accessed like an array even though
                //       it is of type object.
                let rowEle = rowList[0];
                let rowHeight = rowEle.clientHeight;
                let totalRowsHeight = rowHeight * rowList.length;

                let headerEle = headerList[0];
                let headerHeight = headerEle.clientHeight;
                let totalHeadersHeight = headerHeight * headerList.length;
                
                // Get min and max height property
                let tableWrapperEle_computedStyle = window.getComputedStyle(tableWrapperEle);

                let tableWrapperMinHeight_string = tableWrapperEle_computedStyle.getPropertyValue("min-height").replace(/\D*/g,"");
                let tableWrapperMinHeight_stringValidated = isStringTrimNotEmpty(tableWrapperMinHeight_string)? tableWrapperMinHeight_string: 0;
                let tableWrapperMinHeight = parseFloat(tableWrapperMinHeight_stringValidated);
        
                let tableWrapperMaxHeight_string = tableWrapperEle_computedStyle.getPropertyValue("max-height").replace(/\D*/g,"");
                let tableWrapperMaxHeight_stringValidated = isStringTrimNotEmpty(tableWrapperMaxHeight_string)? tableWrapperMaxHeight_string: 0;
                let tableWrapperMaxHeight = parseFloat(tableWrapperMaxHeight_stringValidated);

                let tableHeight = totalHeadersHeight + totalRowsHeight + 8; // Extra 7px is due to scrollbar width
                if (tableHeight < tableWrapperMinHeight) tableWrapperEle.style.minHeight = tableHeight + "px";
                if (tableHeight > tableWrapperMaxHeight) tableWrapperEle.style.maxHeight = tableHeight + "px";
                tableWrapperEle.style.height = tableHeight + "px";
            }
        }
    }
    useEffect(() => {
        wrapHeight();
    }, [isTableDoneRendering]);
}